import { gsap } from 'gsap';
import { useEffect } from 'react';

import { setAnimationToIllustrationsPaths } from '@components/Sections/utils/animations';

import {
  StyledComputer,
  StyledEye,
  StyledHealthArmour,
  StyledStereotypes,
  StyledZigZags,
} from './IllustrationPens.styled';

export const IllustrationPens: React.FC = () => {
  useEffect(() => {
    const ctx = gsap.context(() => {
      setAnimationToIllustrationsPaths({
        illustration: '.stereotypes path',
        trigger: '.stereotypes',
        startPosition: 'bottom 90%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.computer path',
        trigger: '.computer',
        startPosition: 'bottom 95%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.health-armour path',
        trigger: '.health-armour',
        startPosition: 'bottom 80%',
      });
      setAnimationToIllustrationsPaths({
        illustration: '.zig-zags path',
        trigger: '.zig-zags',
        startPosition: 'bottom 80%',
        delay: 0.25,
      });
      setAnimationToIllustrationsPaths({
        illustration: '.eye path',
        trigger: '.eye',
        startPosition: 'bottom 90%',
      });
    });

    return () => ctx.revert();
  }, []);

  return (
    <>
      <StyledHealthArmour className="health-armour" role="presentation" aria-hidden />
      <StyledZigZags className="zig-zags" role="presentation" aria-hidden />
      <StyledEye className="eye" role="presentation" aria-hidden />
      <StyledStereotypes className="stereotypes" role="presentation" aria-hidden />
      <StyledComputer className="computer" role="presentation" aria-hidden />
    </>
  );
};
